<div class="mobile-header">
    <div (click)="toggleDrawer()" style="height: 100%; display: flex; align-items: center;">
        <img src="assets/icons/menu.svg" class="mobile-header-menu-icon" [hidden]="DrawerOpen"/>
        <img src="assets/icons/close-white.svg" class="mobile-header-menu-icon" [hidden]="!DrawerOpen"/>
    </div>
    <a (click)="redirect('/')" style="cursor: pointer"><img src="assets/images/HITEC-logo.png"
                                                            style="max-height: 50px; margin-left: 20px; margin-right: 10px"></a>
    <h4 *ngIf="isActiveSite('')" class="current-site-title">{{"NAV.HOME" | translate }}</h4>
    <h4 *ngIf="isActiveSite('/about')" class="current-site-title">{{"NAV.ABOUT" | translate }}</h4>
    <h4 *ngIf="isActiveSite('/services')" class="current-site-title">{{"NAV.SERVICES" | translate }}</h4>
    <h4 *ngIf="isActiveSite('/products')" class="current-site-title">{{"NAV.PRODUCTS" | translate }}</h4>
    <h4 *ngIf="isActiveSite('/products/excavators')" class="current-site-title">{{"NAV.KAIVURIT" | translate }}</h4>
    <h4 *ngIf="isActiveSite('/products/mulchers')"
        class="current-site-title">{{"NAV.VESAKKOMURSKIMET" | translate }}</h4>
    <h4 *ngIf="isActiveSite('/products/special')" class="current-site-title">{{"NAV.ERIKOISSOVELLUS" | translate }}</h4>
    <h4 *ngIf="isActiveSite('/location')" class="current-site-title">{{"NAV.LOCATION" | translate }}</h4>
</div>
<div class="mobile-sidebar" [class]="DrawerVisibilityClass">
    <div style="height: 100%; width: 100%;" [hidden]="!DrawerOpen" [class]="DrawerVisibilityClass">
        <ul>
            <li (click)="redirect('')" class="{{isActiveSite('')}}">
                <h5 class="mobile-sidebar-link">{{"NAV.HOME" | translate }}</h5>
            </li>
            <li (click)="redirect('/about')" class="{{isActiveSite('about')}}">
                <h5 class="mobile-sidebar-link">{{"NAV.ABOUT" | translate }}</h5>
            </li>
            <li (click)="redirect('/services')" class="{{isActiveSite('services')}}">
                <h5 class="mobile-sidebar-link">{{"NAV.SERVICES" | translate }}</h5>
            </li>
            <li (click)="redirect('/products')" class="{{isActiveSite('products')}}">
                <h5 class="mobile-sidebar-link">{{"NAV.PRODUCTS" | translate }}</h5>
            </li>
            <li>
                <ul>
                    <li (click)="redirect('/products/excavators')"
                        class="child-link {{isActiveSite('/products/excavators')}}">
                        <h5 class="mobile-sidebar-link">{{"NAV.KAIVURIT" | translate }}</h5></li>
                    <li (click)="redirect('/products/mulchers')"
                        class="child-link {{isActiveSite('/products/mulchers')}}">
                        <h5 class="mobile-sidebar-link">{{"NAV.VESAKKOMURSKIMET" | translate }}</h5>
                    </li>
                    <li (click)="redirect('/products/special')"
                        class="child-link {{isActiveSite('/products/special')}}">
                        <h5 class="mobile-sidebar-link">{{"NAV.ERIKOISSOVELLUS" | translate }}</h5>
                    </li>
                </ul>
            </li>
            <li (click)="redirect('/location')" class="{{isActiveSite('location')}}">
                <h5 class="mobile-sidebar-link">{{"NAV.LOCATION" | translate }}</h5>
            </li>
            <li class="language-selector">
                <select class="language-selector-dropdown"
                        (change)="changeLanguage($event)"
                        [ngModel]="selectedLanguage">
                    <option *ngFor="let language of languages"
                            [value]="language.value">{{language.name}}</option>
                </select>
                <img style="margin-left: -20px; pointer-events:none;"
                     src="assets/images/dropdownarrow.svg"/>
            </li>
        </ul>
    </div>
</div>
